import type { InputCustomEvent, InputChangeEventDetail } from '@ionic/react'
import { ParseKeys } from 'i18next'
import type { ComponentProps } from 'react'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useParserI18nMessage } from '~/shared/lib/i18n'
import { IonInput } from '../styled'

type TextInputProps = { name: string; label: ParseKeys } & Omit<
  ComponentProps<typeof IonInput>,
  '$invalid'
>

export function TextInput({
  label,
  name,
  type,
  children,
  ...inputProps
}: TextInputProps) {
  const { t } = useTranslation()
  const { parserI18nMessage } = useParserI18nMessage()
  return (
    <Controller
      name={name}
      defaultValue=''
      render={({
        field: { onChange, value },
        fieldState: { error, invalid },
      }) => (
        <IonInput
          onIonInput={(e: InputCustomEvent<InputChangeEventDetail>) => {
            onChange(e.detail.value || '')
          }}
          value={value}
          name={name}
          label={t(label)}
          type={type}
          errorText={parserI18nMessage(
            error?.message || 'validate.required field',
          )}
          $invalid={invalid}
          {...inputProps}
          labelPlacement='floating'
        >
          {children}
        </IonInput>
      )}
    />
  )
}
